<template>
    <div>
        <input :disabled="BaseOpcoes.length == 0" :style="propStyle" ref="inputEl" @blur="fecharLista"
            @focus="mostrarLista = true" type="text" v-model="itemSelecionado"
            :placeholder="propPlaceholder ? propPlaceholder : BaseOpcoes.length == 0 ? '' : 'Adicionar Usuário'" />
        <ul v-if="mostrarLista" class="lista" :style="{ width: inputWidth + 'px' }">
            <li v-for="item in opcoesFiltradas" :key="item.id" @click="adicionarItem(item)">
                {{ item.nomeCompleto }}
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "AutoComplete",
    props: {
        BaseOpcoes: { required: true },
        propStyle: { default: "width: 40rem" },
        propPlaceholder: { required: false }
    },
    data() {
        return {
            mostrarLista: false,
            itemSelecionado: '',
            inputWidth: 0,
        };
    },

    mounted() {
        // Mede largura inicial
        this.atualizarLargura();

        // Atualiza se a janela for redimensionada
        window.addEventListener("resize", this.atualizarLargura);
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.atualizarLargura);
    },

    methods: {
        atualizarLargura() {
            this.$nextTick(() => {
                if (this.$refs.inputEl) {
                    this.inputWidth = this.$refs.inputEl.offsetWidth;
                }
            });
        },
        adicionarItem(item) {
            this.itemSelecionado = '';
            this.$emit("adicionar", item);
        },
        fecharLista() {
            setTimeout(() => {
                this.mostrarLista = false;
            }, 200);
        },
    },
    computed: {
        opcoesFiltradas() {
            const opcoes = this.BaseOpcoes;
            const descricaoSelecionada = this.itemSelecionado.toLowerCase();

            return opcoes.filter((item) => {
                const descricao = item.nomeCompleto?.toLowerCase();
                return descricao.includes(descricaoSelecionada)
            });
        }
    },
};
</script>
<style scoped>
.lista {
    background-color: var(--cor-bg);
    z-index: 99999;
    position: absolute;
    list-style-type: none;
    color: var(--cor-fonte) !important;
    max-height: 14rem;
    overflow-y: auto;
    overflow-x: hidden;

    li {
        padding: .5rem;
        cursor: pointer;
        border: 1px solid var(--cor-separador);
        background-color: var(--cor-bg);
    }

    li:hover {
        background-color: var(--cor-primaria-fraca);
    }
}
</style>
